import { render, staticRenderFns } from "./ListBlocklistCorretoras.vue?vue&type=template&id=7d9f8e7c"
import script from "./ListBlocklistCorretoras.vue?vue&type=script&lang=js"
export * from "./ListBlocklistCorretoras.vue?vue&type=script&lang=js"
import style0 from "./ListBlocklistCorretoras.vue?vue&type=style&index=0&id=7d9f8e7c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports